import styled from 'styled-components';

export const BusRating = styled.div(
  props => `
    display: flex;
    flex-direction: row;
    align-items: center;
    border-radius: 0.3rem;
    color: white;
    min-width: 3rem;
    align-items: center;
    justify-content: center;
    padding: 0 0.2rem;
    &.greenDr{ background: #18a160}
    &.greenLt{ background: #79d148}
    &.yellow{ background: #f39c12}
    &.red{ background: #ff3a5c}
    `,
);

export const RatingNumber = styled.span`
  color: white;
  font-size: 1.1rem;
  font-weight: bold;
`;
